import { Router } from "@vaadin/router";
import { html, LitElement } from "lit";

import "./pages/notfound";
import "./pages/home";
import "./pages/livemap";
import "./pages/leaderboard";
import "./pages/user";
import "./pages/flight.js";
import "./pages/mapselect.js";

export class AppRouter extends LitElement {
  static get properties() {
    return {
      route: { type: String, state: true },
    };
  }

  constructor() {
    super();
    this.router = null;
  }

  firstUpdated() {
    // Setup router.
    const { POPSTATE } = Router.NavigationTrigger;
    Router.setTriggers(POPSTATE);
    const outlet = this.shadowRoot.querySelector("div");
    this.router = new Router(outlet);
    this.router.setRoutes([
      {
        path: "/",
        component: "home-page",
      },
      {
        path: "/live-map",
        component: "live-map-page",
      },
      {
        path: "/map-select",
        component: "map-select-page",
      },
      {
        path: "/leaderboard",
        component: "leaderboard-page",
      },
      {
        path: "/user/:id",
        component: "user-page",
      },
      {
        path: "/flight/:id",
        component: "flight-page",
      },
      {
        path: "(.*)",
        action: (context, commands) => {
          if (
            context.pathname.startsWith("/auth") ||
            context.pathname.startsWith("/manual")
          ) {
            window.location.href = context.pathname;
            return;
          }
          return commands.component("not-found-page");
        },
      },
    ]);
  }

  render() {
    return html` <div></div> `;
  }
}

customElements.define("app-router", AppRouter);
